import { cn } from '@brimostech/ui';

export function BrandMark({ className }: { className?: string }) {
  return (
    <span
      aria-hidden
      className={cn(
        'flex size-8 shrink-0 items-center justify-center rounded-lg bg-primary text-primary-foreground',
        className,
      )}
    >
      <svg viewBox="0 0 32 32" className="size-5" fill="currentColor">
        <path d="M9 23V12.5L16 8l7 4.5V23h-4.5v-6h-5v6z" />
      </svg>
    </span>
  );
}

export function Brand({
  inverted = false,
  compact = false,
}: {
  inverted?: boolean;
  compact?: boolean;
}) {
  return (
    <div className="flex items-center gap-2.5">
      <BrandMark className={inverted ? 'bg-white/15 text-white' : undefined} />
      {compact ? null : (
        <div className="leading-tight">
          <div className={cn('text-sm font-semibold', inverted && 'text-white')}>Brimostech</div>
          <div className={cn('text-xs text-muted-foreground', inverted && 'text-white/70')}>
            Condomínio
          </div>
        </div>
      )}
    </div>
  );
}
